var map = {
	"./b_b.png": 529,
	"./b_w.png": 354,
	"./k_b.png": 230,
	"./k_w.png": 783,
	"./n_b.png": 394,
	"./n_w.png": 245,
	"./p_b.png": 702,
	"./p_w.png": 222,
	"./q_b.png": 547,
	"./q_w.png": 917,
	"./r_b.png": 918,
	"./r_w.png": 975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;